<template>
  <div class="wrapper">
    <div class="inp">
      <span class="label">请输入会议码:</span>
      <input type="text" ref="input" v-model="eventId" />
      <el-button type="primary" @click="handleNext">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { getLogin, checkSign } from "@/api/login";

export default {
  data() {
    return {
      eventId: "",
      unionId: "",
    };
  },

  created() {
    const code = this.$route.query.code;
    getLogin({ code }).then((res) => {
      if (res.status == 200) {
        this.unionId = res.result.unionId;
      } else {
        this.$message.warning(res.message);
        setTimeout(() => {
          this.$router.replace("/");
        }, 1000);
      }
    });
  },

  mounted() {
    this.$refs.input.focus();
  },

  components: {},

  computed: {},

  methods: {
    handleNext() {
      checkSign({ unionId: this.unionId, eventId: this.eventId }).then(
        (res) => {
          console.log(res);
          switch (res.status) {
            case 201:
              this.$router.push({
                name: "UserAuthentication",
                params: { info: res.result },
              });
              break;
            case 200:
              this.$router.push({
                name: "meetinglink",
                params: { result: res.result },
              });
              break;

            default:
              this.$message.warning(res.message);
          }
        }
      );
    },
  },
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
  background-color: rgb(242, 242, 242);
  display: flex;
  justify-content: center;
}
.wrapper .inp {
  margin-top: 300px;
}
.wrapper .inp input {
  height: 45px;
  margin-right: 20px;
  font-size: 25px;
  font-weight: 700;
  width: 200px;
}
.wrapper .inp .label {
  font-size: 35px;
  margin-right: 20px;
  vertical-align: sub;
}
</style>